import { OPSequence } from "./OPSequenceViewModel";
export class WorkOrder{
    WorkOrderNo: string;
    WorkOrderDesc: string;
    WOStatus:string;
    opSequence: OPSequence[]=[]
}